<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="confirmText"
    :title="title"
    width="30%"
    :cancel-disable="cancelDisable"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        v-if="step === 1"
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="手机号码"
          prop="mobile"
        >
          <el-input v-model="createForm.mobile" />
        </el-form-item>
      </el-form>
      <div
        v-else
        class="wx-info"
      >
        <div class="avatar">
          <img
            :src="wxInfo.wechatAvatarUrl"
          >
        </div>
        <div class="info">
          <div class="item name">
            <span>微信昵称:</span>
            <span>{{ wxInfo.wechatNickName }}</span>
          </div>
          <div class="item">
            <span>手机号码:</span>
            <span>{{ wxInfo.mobilePhone }}</span>
          </div>
        </div>
      </div>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import { validateMobile } from '@/util/validate';
import axClient from '@/services';

export default {
  name: 'UserWxInfo',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    checkMobile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title: '新建人员',
      cancelText: '取消',
      step: 1,
      createForm: {
        mobile: null,
      },
      creatRules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
      },
      wxInfo: {},
    };
  },
  computed: {
    confirmText() {
      return this.step === 1 ? '下一步' : '保存';
    },
    cancelDisable() {
      return false;
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.step = 1;
        this.createForm.mobile = null;
      }
    },
  },
  methods: {
    close() {
      if (this.step !== 1) {
        this.step = 1;
        return;
      }
      this.$emit('update:dialogVisible', false);
    },
    confirm() {
      if (!this.checkMobile) {
        this.$refs.createForm.validate(async (valid) => {
          if (valid) {
            this.wxInfo = {
              id: null, mobilePhone: this.createForm.mobile, wechatAvatarUrl: null, wechatNickName: null,
            };
            this.$emit('getWxInfo', this.wxInfo);
            this.$emit('update:dialogVisible', false);
          }
        });
        return;
      }
      if (this.step === 2) {
        this.$emit('getWxInfo', this.wxInfo);
        this.$emit('update:dialogVisible', false);
        return;
      }
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.common.checkMobile({ checkType: 20, mobilePhone: this.createForm.mobile });
          if (data.id === -1) {
            this.$message.error('该手机号码不存在，请先注册口袋阿姨小程序');
            return;
          }
          if (data.id === -2) {
            this.$message.error('该手机号码已绑定账号');
            return;
          }
          const {
            id, mobilePhone, wechatAvatarUrl, wechatNickName,
          } = data;
          this.wxInfo = {
            id, mobilePhone, wechatAvatarUrl, wechatNickName,
          };
          this.step = 2;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  display: flex;
  justify-content: center;
  .el-form{
    width: 80%;
  }
  .wx-info {
    text-align: center;
    display: flex;
    align-items: center;
    .avatar{
      width: 50px;
      height: 50px;
      margin-right: 20px;
    }
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: inline-block;
    }
    .item {
      margin-bottom: 10px;
      span {
        font-size: 14px;
        color: $--base-color-black;
        margin-bottom: 10px;
        &:last-child {
          padding-left: 8px;
          &:last-child{
            color: $--base-color-main;
          }
        }
      }
    }
  }
}

</style>
